var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AndroidImportSuccess"},[_c('img',{attrs:{"src":require('@/assets/images/success.svg')}}),_c('h2',[_vm._v("Import zakończono sukcesem")]),_c('span',[_vm._v("Możesz wyjść z tego okna")])])}
var staticRenderFns = []

export { render, staticRenderFns }